import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { FileCheck2, BadgeEuro } from 'lucide-react';
import { noticesApi } from '../services/api';

export const NOTICE_KEY = 'pricing-2026-einvoice';
export const SNOOZE_KEY = 'pricing_notice_snoozed';

export const PricingNoticeModal = ({ user, onDone }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user || user.role === 'super_admin' || sessionStorage.getItem(SNOOZE_KEY)) { onDone?.(); return; }
    noticesApi.get(NOTICE_KEY).then((r) => { if (!r.data.accepted) setOpen(true); else onDone?.(); }).catch(() => onDone?.());
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const later = () => { sessionStorage.setItem(SNOOZE_KEY, '1'); setOpen(false); onDone?.(); };
  const accept = async () => {
    try { await noticesApi.accept(NOTICE_KEY); } catch { /* riappare al prossimo login */ }
    setOpen(false);
    onDone?.();
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent data-testid="pricing-notice-modal" className="sm:max-w-[520px] [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-['Manrope'] text-xl">Novità importanti</DialogTitle>
          <DialogDescription>Leggi e conferma per continuare.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 text-sm">
          <div className="flex gap-3 p-3 rounded-md bg-emerald-50 border border-emerald-200 text-emerald-900">
            <FileCheck2 className="w-5 h-5 shrink-0 mt-0.5" />
            <p data-testid="pricing-notice-einvoice"><b>Arriva la fatturazione elettronica!</b> Crea le fatture dai tuoi DDT e inviale allo SDI direttamente dall'app. Puoi provarla <b>gratis per 7 giorni</b> dalla sezione "Fatture"; dopo la prova è una funzionalità a pagamento.</p>
          </div>
          <div className="flex gap-3 p-3 rounded-md bg-amber-50 border border-amber-200 text-amber-900">
            <BadgeEuro className="w-5 h-5 shrink-0 mt-0.5" />
            <p data-testid="pricing-notice-price">Al prossimo rinnovo il canone dell'app passerà da <b>200 €</b> a <b>400 € annuali</b>.</p>
          </div>
          <div dir="rtl" lang="ar" data-testid="pricing-notice-ar" className="text-xs leading-relaxed text-muted-foreground border-t pt-3">
            وصلت الفوترة الإلكترونية! جرّبها مجاناً لمدة 7 أيام من قسم "Fatture"، وبعد التجربة تصبح خدمة مدفوعة. عند التجديد القادم سيرتفع الاشتراك من 200€ إلى 400€ سنوياً.
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button data-testid="pricing-notice-later-btn" variant="outline" onClick={later}>Ricordamelo dopo</Button>
          <Button data-testid="pricing-notice-accept-btn" className="btn-primary" onClick={accept}>Accetta</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PricingNoticeModal;
